<template>
  <div style="display: flex; flex-direction: column; height: 100%;">
    <v-card
      style="border: 2px solid rgb(76, 175, 80); border-radius: 12px; flex: 1;"
    >
      <v-card-text>
        <div
          class="mt-0 ml-3 my-2 body-1 font-weight-light"
          style="position: relative;"
        >
          <v-icon
            dark
            style="position: absolute; top: 0px; right: 0px; font-size: 50px; z-index: 1;"
            :color="getStatusIconColor()"
            >{{ getStatusIcon() }}</v-icon
          >
          <v-layout v-if="technicianMode" row class="mb-3">
            <span class="font-weight-light mr-2">
              ManageEngine ID:
            </span>
            <span class="font-weight-medium">
              {{ request.manageengineID }}
            </span>
          </v-layout>
          <v-layout row class="mb-3">
            <span class="font-weight-light mr-2">
              Ticket Number:
            </span>

            <span class="font-weight-medium">
              {{ request.displayID }}
            </span>
          </v-layout>
          <v-layout row align-center class="mb-3">
            <span class="font-weight-light mr-2" style="flex: 0 0 auto;">
              Status:
            </span>
            <v-flex shrink class="pa-0 ma-0" style="min-width: 0;">
              <span v-if="!technicianMode" class="font-weight-medium">
                {{ request.statusName }}
              </span>
              <span
                v-else-if="!showStatusDropdown"
                class="font-weight-medium"
                @click="(showStatusDropdown = true), (statusPointer = false)"
                @mouseover="statusPointer = true"
                @mouseleave="statusPointer = false"
                style="cursor: pointer;"
              >
                {{ request.statusName }}
                <v-icon v-if="statusPointer" small class="ml-1"
                  >mdi-pencil</v-icon
                >
              </span>
              <v-select
                v-else
                v-model="selectedStatus"
                :items="['Open', 'Closed', 'On Hold']"
                item-text="text"
                item-value="value"
                dense
                hide-details
                class="font-weight-medium ma-0 pt-0"
                style="max-width: 100px;"
                @change="onStatusChange"
                @blur="showStatusDropdown = false"
                @focus="selectedStatus = request.statusName"
                autofocus
              ></v-select>
            </v-flex>
          </v-layout>

          <v-layout row align-center class="mb-3">
            <span class="font-weight-light mr-2" style="flex: 0 0 auto;">
              Technician:
            </span>
            <v-flex shrink class="pa-0 ma-0" style="min-width: 0;">
              <span v-if="!technicianMode" class="font-weight-medium">
                {{ request.technicianName || "Not assigned" }}
              </span>
              <span
                v-else-if="!showTechnicianDropdown"
                class="font-weight-medium"
                @click="
                  (showTechnicianDropdown = true),
                    (technicianPointer = false),
                    getTechnicians()
                "
                @mouseover="technicianPointer = true"
                @mouseleave="technicianPointer = false"
                style="cursor: pointer;"
              >
                {{ request.technicianName || "Not assigned" }}
                <v-icon v-if="technicianPointer" small class="ml-1"
                  >mdi-pencil</v-icon
                >
              </span>
              <v-autocomplete
                v-else
                v-model="selectedTechnician"
                :items="
                  technicians.length > 0
                    ? technicians.map((t) => t.name)
                    : [request.technicianName]
                "
                placeholder="Select Technician"
                dense
                hide-details
                clearable
                class="font-weight-medium ma-0 pt-0"
                style="max-width: 220px;"
                @change="onTechnicianChange"
                @blur="showTechnicianDropdown = false"
                autofocus
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout row align-center class="mb-3">
            <span class="font-weight-light mr-2" style="flex: 0 0 auto;">
              Category:
            </span>
            <v-flex shrink class="pa-0 ma-0" style="min-width: 0;">
              <span v-if="!technicianMode" class="font-weight-medium">
                {{ request.categoryName }}
              </span>
              <span
                v-else-if="!showCategoryDropdown"
                class="font-weight-medium"
                @click="
                  (showCategoryDropdown = true),
                    (categoryPointer = false),
                    getCategories()
                "
                @mouseover="categoryPointer = true"
                @mouseleave="categoryPointer = false"
                style="cursor: pointer;"
              >
                {{ request.categoryName }}
                <v-icon v-if="categoryPointer" small class="ml-1"
                  >mdi-pencil</v-icon
                >
              </span>
              <v-autocomplete
                v-else
                v-model="selectedCategory"
                :items="
                  categories.length > 0
                    ? categories.map((c) => c.name)
                    : [request.categoryName]
                "
                placeholder="Select Category"
                dense
                hide-details
                class="font-weight-medium ma-0 pt-0"
                style="max-width: 220px;"
                @change="onCategoryChange"
                @blur="showCategoryDropdown = false"
                autofocus
              ></v-autocomplete>
            </v-flex>
          </v-layout>

          <v-layout row align-center class="mb-3">
            <span class="font-weight-light mr-2" style="flex: 0 0 auto;">
              Priority:
            </span>
            <v-flex shrink class="pa-0 ma-0" style="min-width: 0;">
              <span v-if="!technicianMode" class="font-weight-medium">
                <v-icon id="PriorityColor" small :color="getPriority().color"
                  >mdi-box-shadow</v-icon
                >
                {{ getPriority().text }}
              </span>
              <span
                v-else-if="!showPriorityDropdown"
                class="font-weight-medium"
                @click="
                  (showPriorityDropdown = true), (priorityPointer = false)
                "
                @mouseover="priorityPointer = true"
                @mouseleave="priorityPointer = false"
                style="cursor: pointer;"
              >
                <v-icon id="PriorityColor" small :color="getPriority().color"
                  >mdi-box-shadow</v-icon
                >
                {{ getPriority().text }}
                <v-icon v-if="priorityPointer" small class="ml-1"
                  >mdi-pencil</v-icon
                >
              </span>
              <v-autocomplete
                v-else
                v-model="selectedPriority"
                :items="priorityOptions.map((p) => p.text)"
                placeholder="Select Priority"
                dense
                hide-details
                class="font-weight-medium ma-0 pt-0"
                style="max-width: 220px;"
                @change="onPriorityChange"
                @blur="showPriorityDropdown = false"
                autofocus
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout row align-center class="mb-3">
            <span class="font-weight-light mr-2" style="flex: 0 0 auto;">
              Site:
            </span>
            <v-flex shrink class="pa-0 ma-0" style="min-width: 0;">
              <span class="font-weight-medium">
                {{ request.requestSiteName }}
              </span>
            </v-flex>
          </v-layout>

          <v-layout v-if="request.statusName !== 'Closed'" row class="mb-3">
            <span class="font-weight-light mr-2">
              ETA:
            </span>

            <span class="font-weight-medium">
              {{ getETA() }}
            </span>
          </v-layout>
          <b class="mt-2 ml-0 pr-0" v-html="getClosedInfo()"></b>
          <v-divider
            v-if="getAttachments().length > 0"
            class="my-3"
          ></v-divider>
          <div v-if="getAttachments().length > 0">
            <div class="font-weight-medium" style="text-align: center;">
              <v-icon color="blue" dark>mdi-attachment</v-icon>
              {{ getAttachmentCountText() }}
            </div>
            <div style="width: 85%; margin: auto;">
              <div
                v-for="attachment in getAttachments()"
                :key="attachment.name"
              >
                <div
                  v-if="!isAudioFile(attachment.name)"
                  class="audio-attachment-row mt-1"
                  style="cursor: pointer;"
                  @click="loadFile(attachment)"
                >
                  <v-icon color="blue" small>mdi-file</v-icon>
                  <span style="flex: 1; font-size: 13px;">{{
                    truncateText(attachment.name)
                  }}</span>
                  <v-icon small color="blue">mdi-open-in-new</v-icon>
                </div>

                <div v-else class="audio-attachment-row mt-1">
                  <audio controls style="height: 18px;">
                    <source :src="getAudioSrc(attachment)" type="audio/mpeg" />
                  </audio>
                  <v-icon small @click="loadFile(attachment)" color="blue"
                    >mdi-open-in-new</v-icon
                  >
                </div>
              </div>
            </div>
            <v-divider class="mt-3 mb-3"></v-divider>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <CloseTicketDialog
      v-if="request && request.id"
      v-model="closeTicketDialog"
      :initial-data="{ request: request, technicianMode: true }"
      @tickedClosed="$emit('updated')"
    />
  </div>
</template>

<script>
import { truncate, pluralize } from "../../utils/helpers.js";
import CloseTicketDialog from "./CloseTicketDialog.vue";
import {
  getETA,
  loadFile,
  getStatusIcon,
  getStatusIconColor,
  getClosedInfo,
  isAudioFile,
  getAudioSrc,
  getTechnician,
  priorityOptions,
  getAttachmentCountText,
} from "./helpDeskHelpers.js";
export default {
  components: {
    CloseTicketDialog,
  },
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    technicianMode: false,
    request: null,
    showStatusDropdown: false,
    statusPointer: false,
    selectedStatus: null,
    showTechnicianDropdown: false,
    technicianPointer: false,
    selectedTechnician: null,
    showCategoryDropdown: false,
    categoryPointer: false,
    selectedCategory: null,
    showPriorityDropdown: false,
    priorityPointer: false,
    selectedPriority: null,
    technicians: [],
    categories: [],
    statuses: [],
    priorityOptions: priorityOptions,
    attachments: [],
    closeTicketDialog: false,
  }),
  created() {
    this.request = this.initialData.ticket;
    this.technicianMode = this.initialData.technicianMode;
    this.initializeData();
  },
  watch: {
    initialData(newVal) {
      this.request = newVal.ticket;
      this.technicianMode = newVal.technicianMode;
      this.initializeData();
    },
  },
  methods: {
    initializeData() {
      this.selectedTechnician = this.request.technicianName || null;
      this.selectedCategory = this.request.categoryName || null;
      this.selectedPriority =
        this.priorityOptions.find((p) => p.name === this.request.priorityName)
          .text || null;
    },
    async editTicket(payload) {
      try {
        await this.$http.put(`api/manageengine/editTicket`, payload);
      } catch (e) {
        console.error(e);
        return this.$notify({
          group: "notification",
          text: "Error updating ticket. Please check console for details.",
          type: "error",
        });
      }
      this.$emit("updated");
      this.$notify({
        group: "notification",
        text: "Ticked Updated",
        type: "success",
      });
    },
    getStatusIcon() {
      return getStatusIcon(this.request);
    },
    getStatusIconColor() {
      return getStatusIconColor(this.request);
    },

    getAttachmentCountText() {
      return getAttachmentCountText(this.getAttachments());
    },

    getAttachments() {
      if (!this.request || !this.request.attachments) return [];
      return JSON.parse(this.request.attachments);
    },

    getPriority() {
      return priorityOptions.find((p) => p.name === this.request.priorityName);
    },
    getETA() {
      return getETA(this.request);
    },
    getClosedInfo() {
      return getClosedInfo(this.request);
    },
    getTechnician() {
      return getTechnician(this.request);
    },
    async getCategories() {
      if (this.categories.length > 0) return;
      try {
        const response = await this.$http.get("odata/ManageengineCategories");
        this.categories = response.value.map((m) => ({
          name: m.name,
          id: m.id,
        }));
      } catch (error) {
        console.error(error);
      }
    },
    async onCategoryChange() {
      this.showCategoryDropdown = false;
      const category = this.categories.find(
        (c) => c.name === this.selectedCategory
      );

      this.editTicket({
        CategoryId: category.id,
        ManageengineID: this.request.manageengineID,
        DisplayID: this.request.displayID,
      });
    },
    getStatuses() {
      return getStatuses(this.request);
    },
    isAudioFile(fileName) {
      return isAudioFile(fileName);
    },
    async getTechnicians() {
      if (this.technicians.length > 0) return;
      try {
        const response = await this.$http.get("odata/ManageengineTechnicians");
        this.technicians = response.value.map((m) => ({
          name: m.name,
          id: m.id,
        }));
      } catch (error) {
        console.error(error);
      }
    },
    truncateText(attachment) {
      return truncate(attachment, 35);
    },
    getAudioSrc(file) {
      return getAudioSrc(file);
    },
    loadFile(file) {
      loadFile(file);
    },
    async onStatusChange() {
      this.showStatusDropdown = false;
      if (this.selectedStatus == "Closed") {
        this.closeTicketDialog = true;
        return;
      }
      this.editTicket({
        StatusName: this.selectedStatus,
        ManageengineID: this.request.manageengineID,
        DisplayID: this.request.displayID,
      });
    },
    async onTechnicianChange() {
      this.showTechnicianDropdown = false;
      const technician = this.technicians.find(
        (t) => t.name === this.selectedTechnician
      );
      const technicianId = technician ? technician.id : "clear";
      this.editTicket({
        TechnicianId: technicianId,
        ManageengineID: this.request.manageengineID,
        DisplayID: this.request.displayID,
      });
    },
    async onPriorityChange() {
      this.showPriorityDropdown = false;
      const priority = this.priorityOptions.find(
        (p) => p.text === this.selectedPriority
      );
      this.editTicket({
        PriorityName: priority.name,
        ManageengineID: this.request.manageengineID,
        DisplayID: this.request.displayID,
      });
    },
  },
};
</script>

<style>
.audio-attachment-row {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 4px 8px;
  border: 1px solid #e0e0e0;
}
</style>
